import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { listInput, SCOPES, type ThreadScope } from "../../screens/threads/model.ts";
import { ThreadsIndex } from "../../screens/threads/ThreadsIndex.tsx";

/** `/threads?tab=&area=`: Questions, every conversation with Adea (yours, your team's, Adea's own), by area. */
export const Route = createFileRoute("/_app/threads/")({
  validateSearch: (search: Record<string, unknown>): { tab?: ThreadScope; area?: string } => ({
    ...(SCOPES.includes(search.tab as ThreadScope) && search.tab !== "mine"
      ? { tab: search.tab as ThreadScope }
      : {}),
    ...(typeof search.area === "string" && search.area ? { area: search.area } : {}),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(actions.queryOptions("library.get", {}));
    return context.queryClient.prefetchQuery(actions.queryOptions("threads.list", listInput("mine")));
  },
  component: ThreadsIndex,
});
